export default __webpack_public_path__ + "static/media/stone4.fc425162.png";